import { render, staticRenderFns } from "./EndorseButtonNonauth.vue?vue&type=template&id=5d08162e&"
import script from "./EndorseButtonNonauth.vue?vue&type=script&lang=js&"
export * from "./EndorseButtonNonauth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports